import React from "react";

import './FooterOverlay.css';

export default function FooterOverlay() {
    return (
        <div className="app__footerOverlay">
            <div className="app__footerOverlay-black" />
            <div className="app__footerOverlay-img app__bg" />
        </div>
    )
}